import type { AuthResponse, GoogleAuthUrlResponse, User } from '@peles/shared';
import { apiClient } from './client';

export async function getGoogleAuthUrl(): Promise<string> {
  const { data } = await apiClient.get<GoogleAuthUrlResponse>('/auth/google/url');
  return data.url;
}

export async function googleCallback(code: string): Promise<AuthResponse> {
  const { data } = await apiClient.post<AuthResponse>('/auth/google/callback', { code });
  return data;
}

export async function refreshTokens(refreshToken: string): Promise<AuthResponse> {
  const { data } = await apiClient.post<AuthResponse>('/auth/refresh', { refreshToken });
  return data;
}

export async function logout(refreshToken: string): Promise<void> {
  await apiClient.post('/auth/logout', { refreshToken });
}

export async function getMe(): Promise<AuthResponse['user']> {
  const { data } = await apiClient.get<AuthResponse['user']>('/auth/me');
  return data;
}

export async function impersonateUser(
  userId: string,
): Promise<{ accessToken: string; user: User }> {
  const { data } = await apiClient.post<{ accessToken: string; user: User }>(
    `/auth/impersonate/${userId}`,
  );
  return data;
}

export async function getRealUser(): Promise<User | null> {
  const token = localStorage.getItem('real_access_token');
  if (!token) return null;
  try {
    const { data } = await apiClient.get<User>('/auth/me', {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch {
    return null;
  }
}
